import React, { PropsWithChildren } from "react";

import { useSelector } from "react-redux";
import { countriesSelector } from "../../store/ducks/countries/selectors";

interface FlagWrapperProps {
  country: string;
  label?: string;
}

export default function FlagWrapper({ country, label }: PropsWithChildren<FlagWrapperProps>) {
  const countries = useSelector(countriesSelector);
  const abbreviation = countries?.find(countryData => countryData.name === country)?.abbreviation.toLowerCase();

  return (
    <>
      <span className={`fi fi-${abbreviation}`}></span>
      <span style={{marginLeft: "10px"}}>{label || country}</span>
    </>
  );
}
